import type { RelatedProductsProps } from "../types/components/RelatedProductsProps";

import "../assets/scss/components/_related-products.scss";
import { ProductListing } from "./ProductListing";

export const RelatedProducts = ({ info = [] }: RelatedProductsProps) => {
	return info?.length ? (
		<section className="related-products">
			<h3>Not what you're looking for? Why not check out:</h3>

			<div className="row justify-content-lg-space-between">
				{info.map((product, index) => {
					return (
						<ProductListing
							info={product}
							key={index}
							id={product.products_id}
							size={{ base: 6, md: 4 }}
							sort={index}
							msrpShown={false}
						/>
					);
				})}
			</div>
		</section>
	) : null;
};
